import {
    IS_LOADING,
    COMPONENT_SEARCH,
    CLEAR_COMPONENT_SEARCH,
    SET_INPUT_SEARCH,
    SET_SELECTED_TAB,
    GET_PARKS,
    SET_CURRENT_PARK,
    SET_CURRENT_COMPONENT
} from './componentsParkConstants';
import { throwErrorMessage } from '../../lib/error_helper';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { addSearchHistoryLine, getSearchHistoryType } from '../searchHistory/searchHistoryActions';
import { EQUIPMENT_CODE } from '../searchHistory/searchHistoryConstants';
import { getSiteIds } from '../customerSite/customerSiteActions';
import { tryParseInt } from '../../utils';

export function clearComponentsSearchAction() {
    return {
        type: CLEAR_COMPONENT_SEARCH,
        currentComponent: null,
    };
}

export function componentIsLoading(bool) {
    return {
        type: IS_LOADING,
        info: 'componentsPark',
        isLoading: bool,
    };
}

export function componentParkActions(currentComponent) {
    return {
        type: COMPONENT_SEARCH,
        currentComponent: currentComponent,
    };
}

export function setInputSearchActions(inputSearch) {
    return {
        type: SET_INPUT_SEARCH,
        inputSearch: inputSearch,
    };
}

export function setSelectedTabActions(selectedTab) {
    return {
        type: SET_SELECTED_TAB,
        selectedTab: selectedTab,
    }
}

export function setCurrentParkAction(park) {
    return {
        type: SET_CURRENT_PARK,
        currentPark: park,
    }
}

export function setCurrentComponentAction(component) {
    return {
        type: SET_CURRENT_COMPONENT,
        currentComponent: component,
    }
}

export function getParkActions(parks) {
    return {
        type: GET_PARKS,
        parks
    }
}

export function clearComponentsSearch() {
    return (dispatch) => {
        dispatch(clearComponentsSearchAction());
    }
}

export function setInputSearch(inputSearch) {
    return (dispatch) => {
        dispatch(setInputSearchActions(inputSearch));
    }
}

export function setSelectedTab(selectedTab) {
    return (dispatch) => {
        dispatch(setSelectedTabActions(selectedTab));
    }
}

export function getTabs() {
    return [
        {
            id: 0,
            name: "QRCode",
        },
        {
            id: 1,
            name: "ManualSearch",
        }
    ]
}

export function formatStatus(status) {
    if (status === "draft")
        return "Brouillon";
    else if (status === "open")
        return "Ouvert";
    else if (status === "assigned")
        return "Affecté";
    else if (status === "performed")
        return "En intervention";
    else if (status === "done")
        return "Terminé";
    else if (status === "cna_validation")
        return "A valider CNA";
    else if (status === "waiting_for_invoice")
        return "A facturer";
    else if (status === "closed")
        return "Clôturé";
    else if (status === "cancelled")
        return "Annulé";

    return status;
}

export function searchComponent(componentCode, discreetError = false, onSuccess) {
    return (dispatch) => {
        let codeAsInt = tryParseInt(componentCode, false);

        if (!componentCode.startsWith("MAT") && !codeAsInt) {
            if (!discreetError)
                dispatch(throwErrorMessage({
                    title: "Erreur",
                    message: 'Cet équipement est introuvable !',
                }));

            return;
        }

        dispatch(componentIsLoading(true));
        dispatch(addSearchHistoryLine(getSearchHistoryType(EQUIPMENT_CODE), componentCode));

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/components/park/' + componentCode, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                dispatch(componentIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((componentPark) => {
                dispatch(componentParkActions(componentPark))

                if (onSuccess && typeof onSuccess === "function")
                    onSuccess()
            })
            .catch((err) => {
                dispatch(setInputSearch(componentCode));
                dispatch(setSelectedTab(getTabs()[1].id));//On redirige vers l'onglet de saisie manuelle
                console.error("Erreur : componentParksActions - componentPark", err)
                if (!discreetError)
                    dispatch(throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: 'Cet équipement est introuvable !',
                    }));

                dispatch(componentIsLoading(false));
            });
    };
}

export function getParks(customerSiteId, allSites, user) {
    return (dispatch) => {

        if (!customerSiteId)
            return;

        dispatch(componentIsLoading(true));

        let customerSiteIds = getSiteIds(customerSiteId, allSites);
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/park/getParks/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                userId: user.id,
                customerSiteIds,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((parks) => {
                dispatch(getParkActions(parks))
                dispatch(componentIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : componentsParkActions - getParks", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: 'Impossible de récupérer les parcs',
                }));

                dispatch(componentIsLoading(false));
            });
    };
}

export function loadPark(park) {
    return (dispatch) => {
        dispatch(setCurrentParkAction(park));
    }
}

export function loadComponent(component, onSuccess) {
    return (dispatch) => {
        dispatch(searchComponent(component.code, false, onSuccess));
    }
}